const map = {
	"./agency-banque.json": 463,
	"./agency-cabinet-medical.json": 917,
	"./agency-cnas.json": 348,
	"./agency-hopital.json": 288,
	"./agency-laboratoire.json": 453,
	"./agency-mairie-mostaganem.json": 939,
	"./agency-mairie.json": 722,
	"./agency-polyclinique.json": 187,
	"./agency-poste.json": 386,
	"./agency-prefecture.json": 2,
	"./agency-sonelgaz.json": 296,
	"./agency-tigditt.json": 900,
	"./agency-yalidine.json": 918
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 308;